
import { Department } from "@/types";
import { AddDepartmentDialog } from "../AddDepartmentDialog";
import { EditDepartmentDialog } from "../EditDepartmentDialog";

interface DepartmentDialogsProps {
  addDialogOpen: boolean;
  onAddDialogOpenChange: (open: boolean) => void;
  onAddDepartment: (department: Omit<Department, "id">) => Promise<boolean>;
  companyId: string;
  editDialogOpen: boolean;
  onEditDialogOpenChange: (open: boolean) => void;
  selectedDepartment: Department | null;
  onUpdateDepartment: (department: Department) => Promise<boolean>;
  isSubmitting: boolean;
}

export function DepartmentDialogs({
  addDialogOpen,
  onAddDialogOpenChange,
  onAddDepartment,
  companyId,
  editDialogOpen,
  onEditDialogOpenChange,
  selectedDepartment,
  onUpdateDepartment,

  isSubmitting
}: DepartmentDialogsProps) {
  return (
    <>
      <AddDepartmentDialog 
        open={addDialogOpen} 
        onOpenChange={onAddDialogOpenChange}
        onAddDepartment={onAddDepartment}
        companyId={companyId}
      />
      
      {selectedDepartment && (
        <EditDepartmentDialog 
          open={editDialogOpen}
          onOpenChange={onEditDialogOpenChange}
          department={selectedDepartment}
          onSave={onUpdateDepartment}
          isSubmitting={isSubmitting}
        />
      )}
    </>
  );
}
